import { Eye, Globe, Target, Users } from "lucide-react";
import * as React from "react";

export function PrevalenceIcon(
    { prevalence, className }: { prevalence?: string; className?: string },
) {
    if (!prevalence) return null;
    switch (prevalence) {
        case "ubiquitous":
            return <Globe className={className ?? "w-4 h-4"} />;
        case "common":
            return <Users className={className ?? "w-4 h-4"} />;
        case "uncommon":
            return <Eye className={className ?? "w-4 h-4"} />;
        case "niche":
            return <Target className={className ?? "w-4 h-4"} />;
        default:
            return null;
    }
}
